import moment from 'moment';
import { getMeetingBillReport, getMeetingBillReportDownLoad} from '../services/report';

export default {
  namespace: 'meetingBillReport',
  state: {
    nodeCode: '-1',
    deptId: '',
    startTime: null,
    endTime: null,
    pageNo: 1,
    pageSize: 10,
    searchData: [],
    searchInfo:{nodeCode: '-1', startTime: null, endTime: null},
  },
  reducers: {
    setState(state, { payload }) {
      return { ...state, ...payload };
    }
  },
  effects: {
    *searchByParam({ payload }, { call, select, put }) {
      yield put({ type: 'setState', payload: { ...payload } });
      let searchInfo = yield select(state => state.meetingBillReport.searchInfo);
      const {startTime, endTime, nodeCode} = searchInfo;
      let pageNo = yield select(state => state.meetingBillReport.pageNo);
      let pageSize = yield select(state => state.meetingBillReport.pageSize);
      const { locale } = yield select(state => state.i18n);
      let data = yield call(getMeetingBillReport, {
        startDate: startTime ? startTime.startOf('day').valueOf() : "",
        endDate: endTime ? endTime.endOf('day').valueOf() : "",
        nodeCode: nodeCode,
        pageNo,
        pageSize,
        locale
      });
      if (data) {
        yield put({
          type: 'setState',
          payload: { searchData: data.data || [] }
        });
      }
    },
    *downloadBill({}, { select, call }) {
      const { token } = yield select(state => state.login);
      const { locale } = yield select(state => state.i18n);
      let searchInfo = yield select(state => state.meetingBillReport.searchInfo);
      const {startTime, endTime, nodeCode} = searchInfo;
      yield call(getMeetingBillReportDownLoad, {
        startDate: startTime ? startTime.startOf('day').valueOf() : "",
        endDate: endTime ? endTime.endOf('day').valueOf() : "",
        nodeCode: nodeCode,
        locale,
        token
      }); 
    }
  },
  subscriptions: {
    set({ dispatch, history }) {
      return history.listen(({ pathname, query }) => {
        if (pathname.indexOf('meetingBillReport') > -1) {
          dispatch({type: 'account/getDeptTree'});
          let p = {searchInfo:{nodeCode: '-1', startTime: null, endTime: null},
            nodeCode: '-1', deptId: '', startTime: null, endTime: null, pageNo: 1, pageSize: 10};
          dispatch({ type: 'searchByParam', payload: p });
        }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/models/meetingBillReport.js